// TrustBadges.js
import React from "react";
import { motion } from "framer-motion";

// Icons can be from a library like react-icons, or use emojis/SVGs
const ShieldIcon = () => <span>🛡️</span>;
const LockIcon = () => <span>🔒</span>;
const FileIcon = () => <span>📄</span>;
const GlobeIcon = () => <span>🌍</span>;

const TrustBadges = () => {
  return (
    <motion.div
      className="max-w-4xl mx-auto mt-16 text-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.4 }}
    >
      <h3 className="text-lg font-semibold text-white/60">
        Built with Enterprise-Grade Security & Privacy
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-6">
        {/* Badge 1: Encryption */}
        <div className="flex flex-col items-center">
          <div className="text-3xl"><ShieldIcon /></div>
          <p className="mt-2 font-semibold text-white">End-to-End Encryption</p>
          <p className="text-xs text-white/50">Even we can't read your strategy sessions.</p>
        </div>
        {/* Badge 2: Privacy */}
        <div className="flex flex-col items-center">
          <div className="text-3xl"><LockIcon /></div>
          <p className="mt-2 font-semibold text-white">Private by Design</p>
          <p className="text-xs text-white/50">You are the only one who can access your data.</p>
        </div>
        {/* Badge 3: Data Control */}
        <div className="flex flex-col items-center">
          <div className="text-3xl"><FileIcon /></div>
          <p className="mt-2 font-semibold text-white">Full Data Control</p>
          <p className="text-xs text-white/50">Export or delete your data permanently at any time.</p>
        </div>
        {/* Badge 4: Compliance */}
        <div className="flex flex-col items-center">
          <div className="text-3xl"><GlobeIcon /></div>
          <p className="mt-2 font-semibold text-white">Global Compliance</p>
          <p className="text-xs text-white/50">Built to meet GDPR & CCPA standards.</p>
        </div>
      </div>
    </motion.div>
  );
};

export default TrustBadges;